/**
 * Sound settings — pure data layer (no React).
 *
 * Read/write sound preferences from localStorage.
 * Consumed by lib functions (audioContext, tradeAudio, defenseAudio)
 * and by the useSoundSettings React hook.
 */

const STORAGE_KEY = 'galactus:soundSettings';

export interface SoundSettings {
  tradeSoundEnabled: boolean;
  whaleSoundEnabled: boolean;
  allTradesSound: boolean;
  defenseSoundEnabled: boolean;
  volume: number; // 0-1
}

export const SOUND_DEFAULTS: SoundSettings = {
  tradeSoundEnabled: true,
  whaleSoundEnabled: true,
  allTradesSound: false,
  defenseSoundEnabled: true,
  volume: 0.5,
};

export function readSoundSettings(): SoundSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...SOUND_DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<SoundSettings>;
    return {
      tradeSoundEnabled: parsed.tradeSoundEnabled ?? SOUND_DEFAULTS.tradeSoundEnabled,
      whaleSoundEnabled: parsed.whaleSoundEnabled ?? SOUND_DEFAULTS.whaleSoundEnabled,
      allTradesSound: parsed.allTradesSound ?? SOUND_DEFAULTS.allTradesSound,
      defenseSoundEnabled: parsed.defenseSoundEnabled ?? SOUND_DEFAULTS.defenseSoundEnabled,
      volume: typeof parsed.volume === 'number' ? Math.max(0, Math.min(1, parsed.volume)) : SOUND_DEFAULTS.volume,
    };
  } catch {
    return { ...SOUND_DEFAULTS };
  }
}

export function writeSoundSettings(settings: SoundSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    // localStorage full or unavailable
  }
}
